import React, { useState, useEffect } from "react";
import Page from "@atlaskit/page";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import Tabs, { Tab, TabList, TabPanel } from "@atlaskit/tabs";
import ConditionsPage from "./tabs/conditionsTab/ConditionsPage";
import RequestConfiguration from "./tabs/requestTab/RequestConfiguration";
import BehaviourTabPage from "./tabs/behavioursTab/BehaviourTabPage";
import VariablesPage from "./tabs/variablesTab/VariablesPage";
import MenuSectionExtensions from "./extension/MenuSectionExtensions";
import ActionMenu from "./menu/ActionMenu";
import GetHelpExtensions from "./extension/GetHelpExtensions";
import ActionStatusToggle from "./ActionStatusToggle";
import ActionExecutionLog from "../../../executionlog/ActionExecutionLog";
import ShowFullScopeVariablePathExtension from "./extension/ShowFullScopeVariablePathExtension";
import { getExecutionLog } from "../../../../redux/actions/logActions";
import { toggleLoading } from "../../../../redux/actions/messageActions";

const WebActionPage = () => {
  const flow = useSelector((state) => state.integration.flow);
  const { sectionId } = useParams();
  const [currentAction, setCurrentAction] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (flow.actions) {
      const action = flow.actions.find((a) => a.id === sectionId);
      if (action) {
        setCurrentAction(action);
        dispatch(getExecutionLog(flow.id, null, null, null, action?.id));
        dispatch(toggleLoading(true, "Loading..."));
      }
    }
  }, [sectionId, flow]);

  return (
    <Page>
      <Tabs>
        <TabList>
          <Tab>Request</Tab>
          <Tab>Conditions</Tab>
          <Tab>Variables</Tab>
          <Tab>Advanced</Tab>
          <Tab>Log</Tab>
          <div className="ihub-actionmenu-action">
            <GetHelpExtensions />
            <ShowFullScopeVariablePathExtension flowId={flow.id} action={currentAction} />
            <MenuSectionExtensions action={currentAction} />
            <ActionMenu action={currentAction} />
            <ActionStatusToggle action={currentAction} flow={flow} />
          </div>
        </TabList>
        <TabPanel>
          <RequestConfiguration />
        </TabPanel>
        <TabPanel>
          <div className="ihub-log-tab-warpper">
            <ConditionsPage action={currentAction} flow={flow} />
          </div>
        </TabPanel>
        <TabPanel>
          <div className="ihub-log-tab-warpper">
            <VariablesPage action={currentAction} />
          </div>
        </TabPanel>
        <TabPanel>
          <div className="ihub-log-tab-warpper">
            <BehaviourTabPage action={currentAction} />
          </div>
        </TabPanel>
        <TabPanel>
          <div className="ihub-log-tab-warpper">
            <ActionExecutionLog flow={flow} action={currentAction} />
          </div>
        </TabPanel>
      </Tabs>
    </Page>
  );
};
export default WebActionPage;
